import detectIE from './detectIE'

export default function () {
  var rtn = true
  var isIE = detectIE()
  if (isIE) {
    try {
      // eslint-disable-next-line
      var swf1 = new window.ActiveXObject('ShockwaveFlash.ShockwaveFlash')
    } catch (e) {
      rtn = false
    }
  } else {
    try {
      var swf2 = navigator.plugins['Shockwave Flash']
      if (swf2 === undefined) {
        rtn = false
      }
    } catch (e) {

    }
  };
  return rtn
}



//////////////////
// WEBPACK FOOTER
// ./static/js/media-view/detectFlash.js
// module id = null
// module chunks = 